// MO4.1.2
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { Url } from '@wix/da-url';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import Avatar from '../../User/Avatar';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import BasicUserName from '../../User/BasicUserName';
import SubscriberStat from '../../Stats/SubscriberStat';
import useDeviationStats from '../../Stats/useDeviationStats';
import TierPriceWithBadge from '../Helper/TierPriceWithBadge';
import MinimalDumbo from '../Dumbo/MinimalDumbo';
import { getTierDescription } from '../_helpers';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import HiddenOverlay from '../HiddenOverlay';
import s from './TierSidebarCard.scss';
const TierSidebarCard = ({ deviation, biData, className, showRecommendedBadge = true, editTier })=>{
    const { t } = useTranslation();
    const { deviationId, author, title } = deviation;
    const { dollarPrice, isUserSubscribed } = deviation.tier || {};
    const { subscribers, isSubscribable, isInSubscription } = useDeviationStats(deviation);
    const isTierRelated = isSubscribable || isInSubscription;
    const { showBlocked, overrideMatureFilter } = useDeviationMatureFilter(deviation);
    const [matureFilterOverridden, setMatureFilterOverridden] = useState(false);
    const onOverrideFilterClick = useCallback((e)=>{
        overrideMatureFilter();
        setMatureFilterOverridden(true);
        e.stopPropagation();
        e.preventDefault();
    }, [
        overrideMatureFilter,
        setMatureFilterOverridden
    ]);
    if (!(author === null || author === void 0 ? void 0 : author.username) || !dollarPrice) {
        return null;
    }
    const tierEntityId = getDeviationEntityId(deviation);
    const coverWidth = 274;
    const coverHeight = 152;
    const href = isUserSubscribed ? Url.userSubscriptionsPath({
        username: author.username,
        tierDeviationId: deviationId,
        tierContentType: 'deviations',
        anchor: true
    }) : Url.userSubscriptionsDeeplink({
        username: author.username,
        tierEntityId
    });
    const description = getTierDescription(deviation);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: classnames(s['root'], isTierRelated && subscribers === 0 && s['no-subs'], className),
        biData: biData,
        href: href
    }, showBlocked && /*#__PURE__*/ React.createElement(HiddenOverlay, {
        className: s['card-overlay'],
        showBackground: false,
        deviation: deviation,
        overrideMatureFilter: onOverrideFilterClick
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['top-section']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['user-info']
    }, /*#__PURE__*/ React.createElement(Avatar, {
        user: author,
        size: 24,
        withLink: false
    }), /*#__PURE__*/ React.createElement(BasicUserName, {
        usernameClassName: s['username'],
        symbolClassName: s['user-symbol'],
        user: author
    }), isUserSubscribed && /*#__PURE__*/ React.createElement("span", {
        className: s['subscribed']
    }, /*#__PURE__*/ React.createElement(CheckIcon, {
        className: s['subscribed-icon'],
        size: IconSize.SMALLER
    }), ' ', t('deviation.tier.subscribed')))), /*#__PURE__*/ React.createElement("div", {
        className: s['cover-wrapper']
    }, deviation.coverImage ? /*#__PURE__*/ React.createElement(MinimalDumbo, {
        className: s['cover'],
        deviation: deviation.coverImage,
        height: coverHeight,
        width: coverWidth,
        showMatureContent: showBlocked || matureFilterOverridden
    }) : /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['cover'], s['placeholder-cover']),
        style: {
            height: coverHeight
        }
    })), title && /*#__PURE__*/ React.createElement(Heading, {
        className: s['title']
    }, title), /*#__PURE__*/ React.createElement(SubscriberStat, {
        className: s['subscribers'],
        deviation: deviation
    }), description && /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, description), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(TierPriceWithBadge, {
        className: s['price'],
        price: dollarPrice
    })));
};
TierSidebarCard.displayName = 'TierSidebarCard';
export default TierSidebarCard;

//# sourceMappingURL=TierSidebarCard.js.map